/**
 * Amberden — Search in the paper header.
 *
 * The paper header's Search was a plain link to /search while Horizon's header
 * (oxblood room) opened #search-modal, so the same icon did two different
 * things depending on which room you were in — the split the Bag already had,
 * and was fixed for in assets/amberden-bag.js. This closes it for Search.
 *
 * Why an anchor and not a <button> like Horizon's: the href is the fallback.
 * With JavaScript off, or in the window before this module parses, Search still
 * reaches the full /search page instead of being a dead icon. Modified clicks
 * (new tab, middle click) are left alone for the same reason.
 *
 * Horizon's own declarative `on:click="#search-modal/showDialog"` cannot be
 * used here: that delegated handler calls the method but never preventDefaults
 * — correct for the <button> it was written for, and on an anchor it would
 * open the dialog and then navigate away from it.
 *
 * Every failure is silent and lands on the href, which is the behaviour the
 * page shipped with before this file existed.
 */

document.addEventListener('click', function (e) {
  var control = e.target && e.target.closest ? e.target.closest('[data-amb-search]') : null;
  if (!control) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

  // On the search page itself, don't cover the results the visitor is reading.
  if (control.getAttribute('aria-current') === 'page') {
    e.preventDefault();
    return;
  }

  var modal = document.getElementById('search-modal');
  if (!modal) return; // no modal here: follow the link

  // The element may be in the DOM before its module has run, in which case it
  // is not yet a Component and has no showDialog. Upgrading is synchronous and
  // idempotent; if it still isn't ready, fall through to the href rather than
  // swallowing the click.
  if (typeof modal.showDialog !== 'function' && window.customElements) {
    try { window.customElements.upgrade(modal); } catch (err) { /* fall through */ }
  }
  if (typeof modal.showDialog !== 'function') return;

  e.preventDefault();
  modal.showDialog();
});
